module.exports = __webpack_public_path__ + "img/shipo-icon-menu-board.97caf0d0.svg";